import styled from "styled-components";

import { IllustrationContainerContainer } from "../../atoms/IllustrationContainer/styles";
import { NotificationContainerWrapper } from "../../atoms/NotificationContainer/styles";

export const CommentOnTicketNotificationContainer = styled.div`
  ${IllustrationContainerContainer} {
    grid-row: 1 / 5;
  }

  a {
    width: fit-content;
  }

  #admin-console-notification-go-to-ticket {
    margin-bottom: 0.75rem;
    width: fit-content;
  }

  &.refund ${NotificationContainerWrapper} {
    background: linear-gradient(
      90deg,
      rgba(169, 99, 255, 0.12) 0%,
      rgba(32, 32, 32, 0.12) 100%
    );

    border-left: 2px solid #a963ff;
  }

  &.recurrency ${NotificationContainerWrapper} {
    background: linear-gradient(
      90deg,
      rgba(255, 100, 3, 0.12) 0%,
      rgba(32, 32, 32, 0.12) 100%
    );

    border-left: 2px solid #ff6403;
  }
`;

export const CommentOnTicketNotificationImageFallback = styled.div`
  height: 2rem;
  width: 2rem;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background-color: ${({ theme }) => `${theme.notification.highlightText}1a`};
`;

export const NotificationTicketCommentContainer = styled.p`
  --background-color: ${({ theme }) => `${theme.notification.highlightText}1a`};
  --border-invisible: ${({ theme }) => theme.groups.topBarGroupsBackground};

  padding: 0.5rem 1rem;

  border-radius: 4px;

  background: var(--background-color);
  color: ${({ theme }) => theme.notification.highlightText};

  margin: 12px 0;

  -webkit-mask: radial-gradient(circle 8px at left, transparent 7px, black 8px)
      left / 55% no-repeat,
    radial-gradient(circle 8px at right, transparent 7px, black 8px) right / 55%
      no-repeat;

  mask: radial-gradient(circle 8px at left, transparent 7px, black 8px) left /
      55% no-repeat,
    radial-gradient(circle 8px at right, transparent 7px, black 8px) right / 55%
      no-repeat;

  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  max-height: 232px;
`;
